import React, { Component } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, FormControl, MenuItem, Select } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import adminService from "../../Services/adminService";
import moment from "moment";
import Swal from "sweetalert2";

class OpenSupportCasesManager extends Component {
  state = {
    openCases: [],
    processingCases: []
  };

  async componentDidMount() {
    const res = await adminService.getAllOpenSupportCases();
    if (res.success) {
      const openCases = res.supportCases.filter((x) => x.status === "OPEN_CASE");
      const processingCases = res.supportCases.filter((x) => x.status === "IN_PROCESS");

      this.setState({ openCases, processingCases });
    }
  }

  render() {
    return (
      <>
        <Card className="width100">
          <CardContent>
            <h4 className="yellow-color">תמיכות פתוחות</h4>
            {this.state.openCases.map((curOpenCase, index) => {
              return (
                <Accordion key={index + "asds"} className="left mt-10 width100  flex-direction-column ">
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <b className="primary-color">
                      {curOpenCase.officeName} / {curOpenCase.cardNum}
                    </b>
                    <span className="mr-20">---- תאריך יצירה {" -> " + moment(curOpenCase.dateCreated).format("DD/MM/YYYY")}</span>

                    <div className="support-created-by-con">
                      <div className="blue-circle-background center inline-block">
                        {adminService.translateAdminName(curOpenCase.createdBy, curOpenCase.dateCreated)}
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails className="nice-gray fs-14">
                    <div>
                      <div className="cur-support-con">
                        <div className="inline-block right">
                          סיבת פניה
                          <br />
                          <textarea
                            onChange={(e) => this.onChange("openCases", index, "supportReason", e.target.value)}
                            value={curOpenCase.supportReason || ""}
                            style={{ width: "200px" }}
                          />
                        </div>

                        <div className="inline-block right">
                          מענה שלנו
                          <br />
                          <textarea
                            value={curOpenCase.ourCaseResponse || ""}
                            style={{ width: "250px" }}
                            onChange={(e) => this.onChange("openCases", index, "ourCaseResponse", e.target.value)}
                          />
                        </div>

                        <div className="inline-block right">
                          סטטוס חדש
                          <br />
                          <FormControl>
                            <Select
                              value={curOpenCase.status || ""}
                              onChange={(e) => this.onChange("openCases", index, "status", e.target.value)}
                              displayEmpty
                            >
                              <MenuItem value="OPEN_CASE">פתוח</MenuItem>
                              <MenuItem value="IN_PROCESS">בטיפול</MenuItem>
                              <MenuItem value="RESOLVED">סגירת פנייה</MenuItem>
                            </Select>
                          </FormControl>
                        </div>

                        <div className="inline-block right">
                          סיפוק לקוח
                          <br />
                          <FormControl>
                            <Select
                              value={curOpenCase.satisfactionLevel || ""}
                              onChange={(e) => this.onChange("openCases", index, "satisfactionLevel", e.target.value)}
                              displayEmpty
                            >
                              <MenuItem value="7">7</MenuItem>
                              <MenuItem value="6">6</MenuItem>
                              <MenuItem value="5">5</MenuItem>
                              <MenuItem value="4">4</MenuItem>
                              <MenuItem value="3">3</MenuItem>
                              <MenuItem value="2">2</MenuItem>
                              <MenuItem value="1">1</MenuItem>
                            </Select>
                          </FormControl>
                        </div>

                        <div className="inline-block right">
                          הערור נוספות על הלקוח
                          <br />
                          <textarea
                            value={curOpenCase.extraComments || ""}
                            style={{ width: "250px" }}
                            onChange={(e) => this.onChange("openCases", index, "extraComments", e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="mt-20 right">
                        <Button onClick={() => this.updateSupportCase("openCases", index)} color="primary" variant="contained">
                          שמור
                        </Button>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </CardContent>
        </Card>
        <hr className="mt-20 mb-20" />
        <Card className="width100">
          <CardContent>
            <h4 className="yellow-color">תמיכות בטיפול</h4>
            {this.state.processingCases.map((curOpenCase, index) => {
              return (
                <Accordion key={index + "asds"} className="left mt-10 width100  flex-direction-column ">
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <b className="primary-color">
                      {curOpenCase.officeName} / {curOpenCase.cardNum}
                    </b>
                    <span className="mr-20">---- תאריך יצירה {" -> " + moment(curOpenCase.dateCreated).format("DD/MM/YYYY")}</span>

                    <div className="support-created-by-con">
                      <div className="blue-circle-background center inline-block">
                        {adminService.translateAdminName(curOpenCase.createdBy, curOpenCase.dateCreated)}
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails className="nice-gray fs-14">
                    <div>
                      <div className="cur-support-con">
                        <div className="inline-block right">
                          סיבת פניה
                          <br />
                          <textarea
                            onChange={(e) => this.onChange("processingCases", index, "supportReason", e.target.value)}
                            value={curOpenCase.supportReason || ""}
                            style={{ width: "200px" }}
                          />
                        </div>

                        <div className="inline-block right">
                          מענה שלנו
                          <br />
                          <textarea
                            value={curOpenCase.ourCaseResponse || ""}
                            style={{ width: "250px" }}
                            onChange={(e) => this.onChange("processingCases", index, "ourCaseResponse", e.target.value)}
                          />
                        </div>

                        <div className="inline-block right">
                          סטטוס חדש
                          <br />
                          <FormControl>
                            <Select
                              value={curOpenCase.status || ""}
                              onChange={(e) => this.onChange("processingCases", index, "status", e.target.value)}
                              displayEmpty
                            >
                              <MenuItem value="IN_PROCESS">בטיפול</MenuItem>
                              <MenuItem value="RESOLVED">סגירת פנייה</MenuItem>
                            </Select>
                          </FormControl>
                        </div>

                        <div className="inline-block right">
                          סיפוק לקוח
                          <br />
                          <FormControl>
                            <Select
                              value={curOpenCase.satisfactionLevel || ""}
                              onChange={(e) => this.onChange("processingCases", index, "satisfactionLevel", e.target.value)}
                              displayEmpty
                            >
                              <MenuItem value="7">7</MenuItem>
                              <MenuItem value="6">6</MenuItem>
                              <MenuItem value="5">5</MenuItem>
                              <MenuItem value="4">4</MenuItem>
                              <MenuItem value="3">3</MenuItem>
                              <MenuItem value="2">2</MenuItem>
                              <MenuItem value="1">1</MenuItem>
                            </Select>
                          </FormControl>
                        </div>

                        <div className="inline-block right">
                          הערור נוספות על הלקוח
                          <br />
                          <textarea
                            value={curOpenCase.extraComments || ""}
                            style={{ width: "250px" }}
                            onChange={(e) => this.onChange("processingCases", index, "extraComments", e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="mt-20 right">
                        <Button onClick={() => this.updateSupportCase("processingCases", index)} color="primary" variant="contained">
                          שמור
                        </Button>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </CardContent>
        </Card>
      </>
    );
  }

  updateSupportCase = async (listName, index) => {
    const getSupportItem = this.state[listName][index];
    if (!getSupportItem.ourCaseResponse || !getSupportItem.supportReason || !getSupportItem.status || !getSupportItem.satisfactionLevel) {
      Swal.fire("חסר מידע", "יש להוסיף את כל השדות", "warning");
      return;
    }

    const res = await adminService.updateSupportCase(getSupportItem);
    if (res.success) {
      const newState = {};
      let openCases, processingCases;
      if (listName === "openCases") {
        openCases = [...this.state.openCases];
        openCases.splice(index, 1);
        newState.openCases = openCases;
        if (getSupportItem.status === "IN_PROCESS") {
          processingCases = [...this.state.processingCases];
          processingCases.push(getSupportItem);
          newState.processingCases = processingCases;
        }
      } else {
        if (getSupportItem.status === "RESOLVED") {
          processingCases = [...this.state.processingCases];
          processingCases.splice(index, 1);
          newState.processingCases = processingCases;
        }
      }
      this.setState(newState);
    }
  };

  onChange = (listName, index, id, val) => {
    const getList = [...this.state[listName]];
    getList[index][id] = val;

    this.setState({ [listName]: getList });
  };
}

export default OpenSupportCasesManager;
